import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#262626",
  "fill-rule": "evenodd",
  d: "M22.197 2.72a.75.75 0 0 1 0 1.06l-.553.553 2.72 2.72a.75.75 0 0 1 0 1.06l-3.792 3.792a.75.75 0 0 1-1.06 0l-2.72-2.72-4.345 4.345-.005.005a6.167 6.167 0 1 1-1.06-1.06l.005-.005 4.874-4.875 3.792-3.792 1.084-1.083a.75.75 0 0 1 1.06 0m-4.344 5.405 2.189 2.19 2.731-2.732-2.19-2.189zm-10.27 4.542a4.667 4.667 0 1 0 0 9.333 4.667 4.667 0 0 0 0-9.333",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }